exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nsection[data-v-6497416e] {\n  margin-bottom: 20px;\n}\nh6[data-v-6497416e] {\n  font-weight: bold;\n  color: #333;\n}\np[data-v-6497416e] {\n  margin-left: 20px;\n}\n", ""]);

// exports
